import { useState } from 'react';

export default function YearSelect(yearVal) {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
    if (yearVal) {
        setCurrentYear(yearVal);
    }
    console.log("currentYear: " + currentYear)
    return currentYear;
}